<template>
<span>
    <v-img
    :src="lockup"
    contain
    center
    class="mobile-lockup-how"
    @click="goHome"
    width="100vw"
    max-width="750"
    ></v-img>
    <p class="text-center white-text footer-text">UK &amp; Northern Ireland only. 18+. Promotion open 00:01 on 10.10.19 to 23:59 on 30.10.19. 1 x family trip to Lapland max. value £10,000, plus chance to win 1 of 1,000 McCain Oven Mitts instantly. Purchase of McCain Roasts 800g/1.4kg or Gastro Roasts 700g required. No Purchase Necessary in NI. Retain receipt. Internet required.<br />Travel dates &amp; restrictions apply.<br />Entry &amp; Full T&amp;Cs at <a href="/">McCainLapland.com</a></p>
    </span>
</template>

<script>
export default {
  data: () => ({
    lockup : {src:require('../assets/mobile-how.png')}
  }),
  methods: {
      goHome: function() {
          this.$router.push('/');
      }
  }
};
</script>
